import { Switch } from '@arco-design/web-react';
import { ROUTE_PATHS } from '@dmp/constant';
import { useGlobalStore } from '@dmp/stores';
import { DOMAIN_MAP, Environment } from '@dmp/utils/rbac';

export const EnvironmentSwitch = () => {
  const env = useGlobalStore((s) => s.env);

  return (
    <div className="flex items-center gap-[12px]">
      <span className="text-[16px] text-[#333] font-semibold">In {env === Environment.PROD ? 'PROD' : 'Non-Prod'}</span>
      <Switch
        checked={env === Environment.PROD}
        onChange={(checked) => {
          if (checked) {
            window.open(
              `${DOMAIN_MAP[Environment.PROD]}${ROUTE_PATHS.INTERNAL_APP_DATASET_MANAGEMENT_DASHBOARD}`,
              '_blank'
            );
          } else {
            window.open(
              `${DOMAIN_MAP[Environment.DEV]}${ROUTE_PATHS.INTERNAL_APP_DATASET_MANAGEMENT_DASHBOARD}`,
              '_blank'
            );
          }
        }}
      />
      <span className="text-[14px] text-[#333]">(Switch to {env === Environment.PROD ? 'Non-Prod' : 'PROD'})</span>
    </div>
  );
};
